import { getType } from 'deox';
import { AxiosError } from 'axios';
import env from '@/env';
import { resetActions } from '../actions';

type ErrorState = { [id: string]: null | Error | string };

interface ErrorPayload {
  error: Error | string;
}

interface ErrorAction {
  type: string;
  payload?: ErrorPayload;
}

interface ResetAction {
  type: string;
  payload: {
    actionName: string;
  };
}

const getErrorMatches = (actionType: string) => /(.*)_(REQUEST|FAILURE)/.exec(actionType);

const errorReducer = (state: ErrorState = {}, action: ErrorAction | ResetAction): ErrorState => {
  if (action.type === getType(resetActions.reset)) {
    const { actionName } = (action as ResetAction).payload;
    const { [actionName]: _, ...newState } = state;
    return newState;
  }

  const matches = getErrorMatches(action.type);

  if (!matches) {
    return state;
  }

  const [, requestName, requestState] = matches;

  let error = (action as ErrorAction).payload?.error;

  if (error instanceof Error) {
    const axiosErrorData = (error as AxiosError)?.response?.data;
    const errorHttpCode = (error as AxiosError)?.response?.status;

    if (errorHttpCode === 500) {
      error = env.messages.internalError;
    } else {
      error =
        axiosErrorData?.message ||
        axiosErrorData?.error_description ||
        axiosErrorData?.errors?.[0].message ||
        error.message;
    }
  }

  return {
    ...state,
    [requestName]: requestState === 'FAILURE' && error ? error : null,
  };
};

export default errorReducer;
